import { Pipe, PipeTransform } from '@angular/core';
import { TagSearchOrder } from '@app-types/enums/tags';

@Pipe({
  name: 'formatTagsSearchOrders',
  standalone: true,
})
export class FormatTagsSearchOrders implements PipeTransform {
  transform(order: string): TagSearchOrder {
    switch (order) {
      case 'tag':
        return TagSearchOrder.OrderByTag;
      default:
        return TagSearchOrder.OrderByTagId;
    }
  }
}
